import React from 'react'
import { Link } from 'react-router-dom'

export default function VerifyInstallation() {
    return (
        <div style={{ justifyContent: "center", display: "flex", width: "100%" }}>
            <div className="row add-site-cta mt-5">
                <Link to="/" className="btn btn-primary next-step"> Continue To Dashboard <img src="https://webpushrapp-3744.kxcdn.com/assets/images/next.png" /></Link>
            </div>
        </div>
    )
}
